import PropTypes from 'prop-types'
import React from 'react'

// typeof window !== 'undefined' ? require('boxicons') : null

const Card = ({ className, children }) => (
  <div className={`card-container ${className}`}>{children}</div>
)

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}

export default Card



// WEBPACK FOOTER //
// ./src/components/newLayout/components/Card.js